import React, { useContext } from 'react'
import DisplayLayout from 'designer/component/display/layout/FormComponentLayout'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'

const FormComponent = (props) => {
  const { uischema, config = {} } = props
  const designContext = useContext(DesignContext)
  const { isUiChanged } = designContext
  const tabForm = objectPath.get(isUiChanged, ['tabForm', uischema.name])
  const jsonForm = tabForm?.jsonForm || {}

  return (
    <DisplayLayout
      schema={jsonForm?.schema || {}}
      uischema={jsonForm?.uischema || {}}
      config={{ ...config, isFormComponent: true, formComponent: uischema }}
    />
  )
}

export default FormComponent
